var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"careers-global-nav__button",attrs:{"data-click-type":"Global Navigation","data-click-name":_vm.name}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }